module.exports = "/assets/Inter-Regular.26a30a5f.woff2";